/**
 * Code-Stand: ThreeJS r135
 */


// PATCHED ------------------------------------------------------------------
const {
    RGBAFormat,
    RGBFormat,
    ImageLoader,
    Texture,
    Loader
} = THREE;
// --------------------------------------------------------------------------

class TextureLoader extends Loader {

    constructor( manager ) {

        super( manager );

    }

    load( url, onLoad, onProgress, onError ) {

        const texture = new Texture();

        const loader = new ImageLoader( this.manager );
        loader.setCrossOrigin( this.crossOrigin );
        loader.setPath( this.path );

        loader.load( url, function ( image ) {

                texture.image = image;

                // JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
                const isJPEG = url.search( /\.jpe?g($|\?)/i ) > 0 || url.search( /^data\:image\/jpeg/ ) === 0;

                texture.format = isJPEG ? RGBFormat : RGBAFormat;
                texture.needsUpdate = true;

                if ( onLoad !== undefined ) {

                    onLoad( texture );

                }

                // PATCHED ------------------------------------------------------------------
                if (texture.promise) {
                    texture.promiseResolve(texture);
                }
                // --------------------------------------------------------------------------


            }, onProgress,
            // PATCHED ------------------------------------------------------------------
            error => {

                if (texture.promise) {
                    texture.promiseReject(texture);
                }

                if (onError !== undefined) {
                    onError(error);
                }
            }
            // --------------------------------------------------------------------------
        );

        return texture;

    }

}

// PATCHED ------------------------------------------------------------------
THREE.TextureLoader = TextureLoader;
// --------------------------------------------------------------------------
